if (location.hash) {
  setTimeout(function() {

    window.scrollTo(0, 0);
  }, 1);
}
(function($) {

  var viewport = document.documentElement.clientWidth

  $( window ).on(
    'load',
    function() {
      var anchorOffset = $( '.header' ).outerHeight()
      var offset = 0;
      var speed = 800;
      var speed_fix = 200;
      var target = window.location.hash;

      if ($( target ).length) {
          $('html,body').animate({
            scrollTop: $(target).offset().top - anchorOffset
          },{
            duration: speed, // main animation time
            easing: 'linear',
            complete: function() {
              $('html,body').animate({
                scrollTop: $(target).offset().top - anchorOffset,
              },{
                easing: 'linear',
                duration: speed_fix // patch time, this starts after main
              });
            }
          });
        }

        function removeHash() {
        var scrollV, scrollH, loc = window.location;
        if ("pushState" in history) {
          history.pushState( "", document.title, loc.pathname + loc.search );
        } else {
          // Prevent scrolling by storing the page's current scroll offset
          scrollV = document.body.scrollTop;
          scrollH = document.body.scrollLeft;

          loc.hash = "";

          // Restore the scroll offset, should be flicker free
          document.body.scrollTop = scrollV;
          document.body.scrollLeft = scrollH;
        }
      }

      removeHash()
    }
  );

  $( document ).ready(
    function() {
      var anchorOffset = $( '.header' ).outerHeight()
      var offset = 0;
      var speed = 800;
      var speed_fix = 200;

      function cleanURL (url_item) {
        url_item = (url_item[0] == '/') ? url_item.substr( 1 ) : url_item;
        url_item = (url_item[url_item.length - 1] == '/') ? url_item.slice( 0, - 1 ) : url_item;
        return url_item
      }

      $( '.siteWrapper a[href*="#"]:not([href="#"]), .mainContent a[href*="#"]:not([href="#"]), .block a[href*="#"]:not([href="#"]), .footer a[href*="#"]:not([href="#"])' ).click(
        function(e) {
          var currentURL = cleanURL( location.pathname )
          var targetURL = cleanURL( $( this ).attr( 'href' ).split( '#' )[0] )

          if ($( this ).attr( 'href' ).split( '#' )[0] != '' && currentURL != targetURL) {
            e.preventDefault()
            if ($(this).attr('target') == '_blank') {
              window.open($( this ).attr( 'href' ), '_blank');
            } else {
              window.location.replace( $( this ).attr( 'href' ) );
            }
          } else {
            e.preventDefault()
            target = '#' + $( this ).attr( 'href' ).split( '#' )[1]

            if (/^#/.test( target ) === true && $( target ).length) {
              var target = $( this.hash );

              $('html,body').animate({
                scrollTop: target.offset().top - anchorOffset
              },{
                duration: speed, // main animation time
                easing: 'linear',
                complete: function() {
                  $('html,body').animate({
                    scrollTop: target.offset().top - anchorOffset,
                  },{
                    easing: 'linear',
                    duration: speed_fix // patch time, this starts after main
                  });
                }
              });
            }
          }
        }
      );

      $( ".externalLink, .externalLink a" ).attr( "target","_blank" );

      $('.pinOnScroll').each(function(index, val) {
        $(this).clone(true,true).removeClass('pinOnScroll').addClass('pinOnScroll--clone').insertAfter(this)
      });

      // Pin on Scroll
      function pinOnScroll() {
        var e = window, a = 'inner';
        if (!('innerWidth' in window )) {
          a = 'client';
          e = document.documentElement || document.body;
        }
        var viewport = e[ a+'Width' ];

        // Define selectors.
        var target = document.querySelector('.pinOnScroll')

        if (typeof(target) != 'undefined' && target != null) {
          var $clone = $('.pinOnScroll--clone')
          var targetPosition = target.getBoundingClientRect().top

          var navHeight = $('nav.nav').outerHeight()
          if (viewport > 1249) {
            var notificationHeight = $('.showNotification .notificationBar').outerHeight() || 0
          } else {
            var notificationHeight = 0
          }
          var pinOffset = navHeight + notificationHeight - 1

          $clone.css('top', pinOffset)

          if (targetPosition - pinOffset < 1) {
            $clone.addClass('active')
          } else {
            $clone.removeClass('active')
          }
        }
      }

      document.addEventListener( 'scroll', pinOnScroll );
    }
  )
})( jQuery );